import React from 'react'
import SecondHeader from '../components/SecondHeader/SecondHeader'
import Footer from '../components/Footer/Footer'

const PrivacyPolicy = () => {
    return (
        <>
            <SecondHeader />

            <div className="privacy-page-box">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">

                            <h1 className="common-heading page-main-heading">Privacy & Policy</h1>

                            <p className="effective-data-text"><strong>Effective Date:</strong> 11/14/2024</p>

                            <p className="common-text pb-4">At I-Sit Corp, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our services. Please read this policy carefully. If you do not agree with its terms, please do not use our services.</p>

                            <h1 className="common-heading">Information We Collect</h1>
                            <p className="common-text">We may collect the following types of information when you interact with our platform:</p>

                            <ul className="common-list">
                                <li><strong>Personal Information:</strong> Name, email address, phone number, mailing address, payment details, and any other information you voluntarily provide.</li>

                                <li><strong>Usage Data:</strong> Information about your use of our platform, including IP addresses, browser type, pages visited, time spent on the site, and other analytical data.</li>

                                <li><strong>Cookies and Tracking Technologies:</strong> We may use cookies, beacons, and similar technologies to track your activities on our website and improve your user experience.</li>
                            </ul>

                            <h1 className="common-heading">How We Use Your Information</h1>
                            <p className="common-text">We use your information for the following purposes:</p>
                            <ul className="common-list">
                                <li>To provide, operate, and maintain our services.</li>
                                <li>To process transactions and send confirmations.</li>
                                <li>To communicate with you about updates, promotions, and support.</li>
                                <li>To analyze usage trends and improve the functionality of our services.</li>
                                <li>To comply with legal obligations and resolve disputes.</li>
                            </ul>

                            <h1 className="common-heading">Sharing Your Information</h1>
                            <p className="common-text">We do not sell your personal information. However, we may share your information in the following situations:</p>
                            <ul className="common-list">
                                <li><strong>With Service Providers:</strong> Third-party vendors who perform services on our behalf, such as payment processors, marketing agencies, and data analytics providers.</li>

                                <li><strong>For Legal Reasons:</strong> To comply with applicable laws, regulations, or legal processes, or to protect the rights, safety, and property of I-Sit Corp and its users.</li>

                                <li><strong>In Case of Business Transfers:</strong> If we are involved in a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction.</li>
                            </ul>

                            <h1 className="common-heading">Data Security</h1>
                            <p className="common-text">We implement industry-standard measures to protect your information from unauthorized access, use, or disclosure. However, no method of electronic transmission or storage is 100% secure.</p>

                            <h1 className="common-heading">Your Rights and Choices</h1>
                            <p className="common-text">You have the right to:</p>
                            <ul className="common-list">
                                <li>Access and review the information we have about you.</li>
                                <li>Request correction or deletion of your data.</li>
                                <li>Opt-out of receiving promotional emails by following the unsubscribe link in those      communications.</li>
                            </ul>

                            <h1 className="common-heading">Children’s Privacy</h1>
                            <p className="common-text">Our services are not intended for individuals under the age of 13. We do not knowingly collect personal information from children.</p>

                            <h1 className="common-heading">Third-Party Links</h1>
                            <p className="common-text">Our platform may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites.</p>

                            <h1 className="common-heading">Updates to This Policy</h1>
                            <p className="common-text">We may update this Privacy Policy from time to time. The “Effective Date” at the top of this policy indicates when it was last revised. Continued use of our services after changes have been made signifies your acceptance of the updated policy.</p>

                            <h1 className="common-heading">Contact Us</h1>
                            <p className="common-text">If you have questions or concerns about this Privacy Policy, please contact us at:</p>

                            <h1 className="common-heading">I-Sit Corp</h1>
                            <ul className="common-list email-list-side">
                                <li className='email-list'>isit@gmail.com</li>
                                <li className='phone-list'>923232232</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default PrivacyPolicy